import { BACK_ON_AIR_ACTIONS } from '../Actions/BackOnAirActions';

// ─── INITIAL STATE ─────────────────────────────────────────────────────────────
const initialState = {
	loading: {
		importFile:     false,
		lastUpdate:     false,
		generateResult: false,
		helixFetch:     false,
		helixExport:    false,
		helixQueue:     false,
	},
	backOnAir: {
		lastUpdate: {
			user:      null,
			timestamp: null,
		},
		error: null,
	},
	helixQueue: [],
};

// ─── REDUCER ──────────────────────────────────────────────────────────────────
const BackOnAirReducer = (state = initialState, action) => {
	switch (action.type) {

					// ── Import File ────────────────────────────────────────────────────────────
					case BACK_ON_AIR_ACTIONS.BOA_IMPORT_REQUEST:
						return { ...state, loading: { ...state.loading, importFile: true }, backOnAir: { ...state.backOnAir, error: null } };

					case BACK_ON_AIR_ACTIONS.BOA_IMPORT_SUCCESS:
						return {
							...state,
							loading: { ...state.loading, importFile: false },
							backOnAir: { ...state.backOnAir, error: null },
						};

					case BACK_ON_AIR_ACTIONS.BOA_IMPORT_FAILURE:
						return {
							...state,
							loading: { ...state.loading, importFile: false },
							backOnAir: { ...state.backOnAir, error: action.error },
						};

						// ── Get Last Update ────────────────────────────────────────────────────────
					case BACK_ON_AIR_ACTIONS.BOA_GET_LAST_UPDATE_REQUEST:
						return { ...state, loading: { ...state.loading, lastUpdate: true } };

					case BACK_ON_AIR_ACTIONS.BOA_GET_LAST_UPDATE_SUCCESS:
						return {
							...state,
							loading: { ...state.loading, lastUpdate: false },
							backOnAir: { ...state.backOnAir, lastUpdate: action.payload, error: null },
						};

					case BACK_ON_AIR_ACTIONS.BOA_GET_LAST_UPDATE_FAILURE:
						return {
							...state,
							loading: { ...state.loading, lastUpdate: false },
							backOnAir: { ...state.backOnAir, error: action.error },
						};

						// ── Generate Result ────────────────────────────────────────────────────────
					case BACK_ON_AIR_ACTIONS.BOA_GENERATE_REQUEST:
						return { ...state, loading: { ...state.loading, generateResult: true }, backOnAir: { ...state.backOnAir, error: null } };

					case BACK_ON_AIR_ACTIONS.BOA_GENERATE_SUCCESS:
						return { ...state, loading: { ...state.loading, generateResult: false }, backOnAir: { ...state.backOnAir, error: null } };

					case BACK_ON_AIR_ACTIONS.BOA_GENERATE_FAILURE:
						return { ...state, loading: { ...state.loading, generateResult: false }, backOnAir: { ...state.backOnAir, error: action.error } };

						// ── Helix Fetch Data ───────────────────────────────────────────────────────
					case BACK_ON_AIR_ACTIONS.HELIX_FETCH_REQUEST:
						return { ...state, loading: { ...state.loading, helixFetch: true }, backOnAir: { ...state.backOnAir, error: null } };

					case BACK_ON_AIR_ACTIONS.HELIX_FETCH_SUCCESS:
						return { ...state, loading: { ...state.loading, helixFetch: false }, backOnAir: { ...state.backOnAir, error: null } };

					case BACK_ON_AIR_ACTIONS.HELIX_FETCH_FAILURE:
						return { ...state, loading: { ...state.loading, helixFetch: false }, backOnAir: { ...state.backOnAir, error: action.error } };

						// ── Helix Export Result ────────────────────────────────────────────────────
					case BACK_ON_AIR_ACTIONS.HELIX_EXPORT_REQUEST:
						return { ...state, loading: { ...state.loading, helixExport: true }, backOnAir: { ...state.backOnAir, error: null } };

					case BACK_ON_AIR_ACTIONS.HELIX_EXPORT_SUCCESS:
						return { ...state, loading: { ...state.loading, helixExport: false }, backOnAir: { ...state.backOnAir, error: null } };

					case BACK_ON_AIR_ACTIONS.HELIX_EXPORT_FAILURE:
						return { ...state, loading: { ...state.loading, helixExport: false }, backOnAir: { ...state.backOnAir, error: action.error } };

						// ── Helix Get Queue ────────────────────────────────────────────────────────
					case BACK_ON_AIR_ACTIONS.HELIX_GET_QUEUE_REQUEST:
						return { ...state, loading: { ...state.loading, helixQueue: true } };

					case BACK_ON_AIR_ACTIONS.HELIX_GET_QUEUE_SUCCESS:
						return { ...state, loading: { ...state.loading, helixQueue: false }, helixQueue: action.payload ?? [] };

					case BACK_ON_AIR_ACTIONS.HELIX_GET_QUEUE_FAILURE:
						return { ...state, loading: { ...state.loading, helixQueue: false } };

					default:
						return state;
	}
};

export default BackOnAirReducer;